// extracted by mini-css-extract-plugin
export default {"socialIcons":"social_socialIcons__XMzgV"};